import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';

import { useAuthStore } from '../../store/useAuthStore';
import Loading from './Loading';

/**
 * Protege las rutas que exigen sesión iniciada, y opcionalmente un rol.
 *
 * Las trazas de consola que tenía se han quitado (Ola 13): volcaban el objeto
 * de usuario completo en cada evaluación de ruta, de modo que en producción
 * cualquiera con las herramientas del navegador abiertas veía correo, rol e
 * identificador. Sin sesión no revelaban nada; con sesión, todo.
 *
 * La comparación de roles se hace en minúsculas porque el backend devuelve
 * `Superuser` y aquí se escriben de varias formas segun quien tocara el codigo.
 */
const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { user, isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();

  // Mientras se comprueba la sesión no se decide nada: redirigir aquí sacaría
  // al usuario de su propia página en cada recarga.
  if (isLoading) return <Loading message="Verificando sesion..." />;

  if (!isAuthenticated || !user) {
    // `state.from` permite volver a donde iba después de identificarse.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0) {
    const rolDelUsuario = user.role?.toLowerCase();
    const tienePermiso = allowedRoles.some((rol) => rol.toLowerCase() === rolDelUsuario);

    if (!tienePermiso) return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
